export default {
  snackbars: [],
};
